(ns ncr.widgets.edn
  (:require
   [cljs.pprint :as pp]
   [cljs.reader :as reader]
   [cljs.tools.reader.edn :as edn]
   [cljs.tools.reader.reader-types :as edn.reader]
   [clojure.string :as str]
   [clojure.core.match :refer [match]]
   [cljc.java-time.local-date]
   [tick.core :as t]
   ["bignumber.js" :as big]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.pf :as pf]
   [ncr.etc.modal :as m]
   [ncr.etc.pubsub :as ps]
   ["react-simple-code-editor" :default editor]
   ["prismjs" :as prism]))

(defprotocol EdnCodec
  (encode [this data])
  (decode [this data]))

(extend-type nil
  EdnCodec
  (encode [_ data] data)
  (decode [_ data] data))

(reader/register-tag-parser! 'time/date t/date)

(extend-protocol IPrintWithWriter
  big/BigNumber
  (-pr-writer [d out opts]
    (-write out (str "#big/dec \"" d "\""))))

(defn- bigdec [v]
  (big/BigNumber. v))

(reader/register-tag-parser! 'big/dec bigdec)

#_(reader/read-string
    "[#time/date \"2023-11-12\" #big/dec \"123.45\"]")

#_(prn (str (bigdec "123.45")))

(def edn-syntax
  (clj->js
    {:comment
     {:pattern #";.*"
      :greedy true}
     :punctuation #"[{}\[\](),]"}))

(def ^:private edn-readers
  {'big/dec bigdec
   'time/date t/date})

(defn- pprint [in]
  (if (some? in)
    (binding [pp/*print-right-margin* 80]
      (with-out-str (pp/pprint in)))
    ""))

(defn- parse [s]
  (let [reader (edn.reader/string-push-back-reader s)]
    (loop [acc []]
      (let [seg (edn/read {:eof ::eof :readers edn-readers} reader)]
        (if (= seg ::eof)
          (match acc
            []
            nil

            [single]
            single
            _
            acc)
          (recur (conj acc seg)))))))

(defn dialog-body [{:keys [data title codec]}]
  (let
    [{:keys [edn valid? parsed]}
     @(ps/sub-reducer-map!
        {:edn (pprint (when data (decode codec data)))
         :parsed data
         :valid? true}

        {:edn/edit
         (fn [state value]
           (let
             [parsed
              (try
                (parse value)
                (catch js/Error _
                  ::error))]
             (assoc state
               :edn value
               :parsed parsed
               :valid? (not= parsed ::error))))})
     submit
     (fn []
       (m/close! parsed))]

    [m/c-modal
     {:id :edit-edn
      :title (or title "Edit EDN")
      :variant :large
      :is-overflow-visible true
      :actions
      [[pf/c-button
        {:variant :primary
         :is-disabled (not valid?)
         :on-click submit}
        "Ok"]
       [pf/c-button
        {:variant :link :on-click #(m/close! ::cancel)} "Cancel"]]
      :close-value ::cancel}

     [pf/c-form {:on-submit submit}
      [:div {:class :pf-c-form-control
             :style {:height "40em"
                     :overflow :auto}}
       [:> editor
        {:value edn
         :on-value-change
         #(ps/pub-sync!
            [:edn/edit %])
         :highlight #(prism/highlight % edn-syntax)
         :tab-size 4
         :padding "5px"
         :class [:ncr-c-code-editor]
         :style
         {:min-width "100%"
          :min-height "100%"
          :font-family "Fira code, Fira Mono, monospace"
          :font-size 12}}]]]]))

(defn !dialog [{:keys [data title codec] :as opts}]
  (m/!modal #'dialog-body opts))

(defn cancel? [value]
  (= value ::cancel))
